import React, { useEffect, useState, useRef } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { ChevronDownIcon } from 'lucide-react';
type Language = 'en' | 'de' | 'pt' | 'fr' | 'es' | 'it' | 'nl';
const languageLabels: Record<Language, string> = {
  en: 'EN',
  de: 'DE',
  pt: 'PT',
  fr: 'FR',
  es: 'ES',
  it: 'IT',
  nl: 'NL'
};
export function LanguageToggle() {
  const {
    language,
    setLanguage
  } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const handleLanguageSelect = (lang: Language) => {
    setLanguage(lang);
    setIsOpen(false);
  };
  return <div ref={dropdownRef} className="relative border-l border-gray-300 pl-4 ml-2" data-id="element-276" data-mp="16ybytp91gu0s">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-2 px-3 py-1.5 text-xs font-bold uppercase tracking-wider bg-black text-white hover:bg-gray-900 transition-all duration-200" aria-label="Select language" data-id="element-277" data-mp="1bvlon60cb7p5">
        {languageLabels[language as Language]}
        <ChevronDownIcon className="w-3 h-3" data-id="element-278" data-mp="nzzow1aazg45" />
      </button>

      {isOpen && <div className="absolute top-full right-0 mt-2 bg-white border-2 border-black shadow-lg z-50 min-w-[80px]" data-id="element-279" data-mp="syu997nx5cqd">
          {(Object.keys(languageLabels) as Language[]).map(lang => <button key={lang} onClick={() => handleLanguageSelect(lang)} className={`w-full text-left px-4 py-2 text-xs font-bold uppercase tracking-wider transition-all duration-200 ${language === lang ? 'bg-black text-white' : 'hover:bg-gray-100'}`} data-id="element-280" data-mp="11ypopooibtw7">
              {languageLabels[lang]}
            </button>)}
        </div>}
    </div>;
}